import React, {Component, useState} from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import "react-modern-calendar-datepicker/lib/DatePicker.css"

import Select from "react-select"
import ReactExport from "react-data-export"
import FloatingLabelInput from "./FloatingLabelInput";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import {Multiselect} from "multiselect-react-dropdown";
import XLSX from "xlsx";
import {make_cols} from "./MakeColumns";
import Moment from "moment";
import JDate from "jalali-date";

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
            marginTop: "15px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
            padding: " 10px",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
})
const SheetJSFT = [
      "xlsx",
      "xlsb",
      "xlsm",
      "xls",
      "xml",
      "csv",
      "txt",
      "ods",
      "fods",
      "uos",
      "sylk",
      "dif",
      "dbf",
      "prn",
      "qpw",
      "123",
      "wb*",
      "wq*",
      "html",
      "htm",
]
class ChangeUserTherapyList extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)

            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 5,
                  page: 0,
                  organ_user_therapy: {},
                  orderBy: "organ_user_therapy_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newKindOrganrequest: false,
                  showPaperChart:false,
                  showPaperChart2:false,



                  optionFilterSendrequestKind: "",
                  optionAgent: [],
                  optionCompany: [],
                  optionFieldinsurance: [],
                  optionEmployee: [],
                  optionClearingMode: [],
                  optionOrgan: [],
                  selectedOrgan: '',
                  optionContract: [],
                  selectedContract: '',


            }
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2,i) => {
            console.log(row2.kindorgansendrequest_agent_id)
            this.setState(
                {
                      organ_user_therapy_index: i,
                      organ_user_therapy: row2,
                      newKindOrganrequest: true,
                      showPaperChart2: true

                },
                () => {
                }
            )
      }

      newKindOrganrequestFunc = () => {
            console.log(this.state.organ_user_therapy)
            const {organ_user_therapy,agentInfofilter,organ_user_therapy_index} = this.state


            var  temparray= agentInfofilter;

            temparray[organ_user_therapy_index]=organ_user_therapy;

            this.setState({ agentInfofilter: temparray }, () => {})
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getoptionOrgan()
                                    self.getoptionCompany()
                                    self.getoptionAgent()
                                    self.getoptionFieldinsurance()
                                    self.getoptionEmployee()
                                    self.getoptionClearingMode()

                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      handleFile=(index)=> {
            const { agentInfofilter,optionCompany,optionClearingMode, optionAgent,optionFieldinsurance,optionEmployee,selectedContract,selectedOrgan } = this.state
            var dataArray=agentInfofilter;
            if(selectedOrgan!==""&&selectedContract!=="") {
                  if (dataArray[index].status === 0) {
                        var priceDetail = {
                              company_id: optionCompany.find((x) => x.label === dataArray[index].company_name).value,
                              company_name: dataArray[index].company_name,
                              company_logo_url: optionCompany.find((x) => x.label === dataArray[index].company_name).company_logo_url,
                              tip: "",
                              fieldcompany_desc: "",
                              price: dataArray[index].requst_end_price,
                              fieldcompany_link: "",
                              instalment_desc: "",
                              instalment_conditions: ""
                        };


                        console.log(dataArray[index])
                        console.log(dataArray)
                        this.props.props.props.dispatch({
                              type: "WAITSHOW",
                        })
                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function () {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {

                                          dataArray[index].status = 3;
                                          dataArray[index].statusTxt = 'درخواست ارسال شد ';

                                    } else if (arr.result === "repeat") {
                                          dataArray[index].status = 4;
                                          dataArray[index].statusTxt = 'درخواست  تکراری است ';

                                    }else if (arr.result === "error") {
                                          dataArray[index].status = 5;
                                          dataArray[index].statusTxt = 'درخواست   ثبت نشد ';
                                    }

                                    self.setState({requestinfos: dataArray, agentInfofilter: dataArray}, () => {
                                          if (index + 1 < dataArray.length) {
                                                self.handleFile(index + 1);
                                          }
                                    })

                                    self.props.props.props.dispatch({
                                          type: "WITEHIDE",
                                    })
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "add_organ_request")

                        if (this.state.selectedOrgan.value !== "0") {
                              fd.append("organ_id", this.state.selectedOrgan.value)
                        }

                        if (this.state.selectedContract.value !== "0") {
                              fd.append("contract_id", this.state.selectedContract.value)
                        }


                        if (dataArray[index].company_name) {
                              fd.append("company_id", optionCompany.find((x) => x.label === dataArray[index].company_name).value)
                        }

                        fd.append("requst_penalty", dataArray[index].requst_penalty)

                        if (dataArray[index].sodor_date) {
                              var day = dataArray[index].sodor_date % 100;
                              var month = (parseInt(dataArray[index].sodor_date / 100) % 100)
                              var year = (parseInt(dataArray[index].sodor_date / 10000))

                              fd.append('sodor_date', Moment(JDate.toGregorian(year, month, day)).format('YYYY-MM-DD h:mm:ss'));
                        }
                        if (dataArray[index].start_date) {
                              var day = dataArray[index].start_date % 100;
                              var month = (parseInt(dataArray[index].start_date / 100) % 100)
                              var year = (parseInt(dataArray[index].start_date / 10000))

                              fd.append('start_date', Moment(JDate.toGregorian(year, month, day)).format('YYYY-MM-DD h:mm:ss'));


                        }
                        console.log(optionAgent)
                        console.log(optionAgent.find((x) => parseInt(x.label) === parseInt(dataArray[index].agent_code)).value)
                        if (dataArray[index].fieldinsurance) {
                              fd.append("fieldinsurance_id", optionFieldinsurance.find((x) => x.label === dataArray[index].fieldinsurance).value)
                              fd.append("fieldinsurance", optionFieldinsurance.find((x) => x.label === dataArray[index].fieldinsurance).fieldinsurance)
                        }
                        if (dataArray[index].code_rayane) {
                              fd.append("code_rayane", dataArray[index].code_rayane)
                        }
                        if (dataArray[index].id) {
                              fd.append("requestpartner_code", dataArray[index].id)
                        }
                        if (dataArray[index].agent_code) {
                              fd.append("agent_id", optionAgent.find((x) => parseInt(x.label) === parseInt(dataArray[index].agent_code)).value)
                        }

                        if (dataArray[index].num_ins) {
                              fd.append("num_ins", dataArray[index].num_ins)
                        }

                        fd.append("jsonpricing_text", JSON.stringify(priceDetail))


                        fd.append("code_yekta", dataArray[index].code_yekta)


                        if (dataArray[index].employee_name) {
                              fd.append("employee_id", optionEmployee.find((x) => x.label === dataArray[index].employee_name).value)
                        }
                        if (dataArray[index].requst_end_price) {
                              fd.append("requst_end_price", dataArray[index].requst_end_price)
                        }
                        if (dataArray[index].end_date) {
                              var day = dataArray[index].end_date % 100;
                              var month = (parseInt(dataArray[index].end_date / 100) % 100)
                              var year = (parseInt(dataArray[index].end_date / 10000))

                              fd.append('end_date', Moment(JDate.toGregorian(year, month, day)).format('YYYY-MM-DD h:mm:ss'));

                        }
                        if (dataArray[index].name_insurer) {
                              fd.append("name_insurer", dataArray[index].name_insurer)
                        }

                        if (dataArray[index].family_client) {
                              fd.append("family_client", dataArray[index].family_client)
                        }

                        if (dataArray[index].name_client) {
                              fd.append("name_client", dataArray[index].name_client)
                        }
                        if (dataArray[index].nationalcode_insurer) {
                              fd.append("nationalcode_insurer", dataArray[index].nationalcode_insurer)
                        }
                        if (dataArray[index].personalcode_client) {
                              fd.append("personalcode_client", dataArray[index].personalcode_client)
                        }

                        if (dataArray[index].nationalcode_client) {
                              fd.append("nationalcode_client", dataArray[index].nationalcode_client)
                        }
                        if (dataArray[index].mobile_client) {
                              fd.append("mobile_client", dataArray[index].mobile_client)
                        }
                        if (dataArray[index].clearing) {
                              fd.append("clearing", optionClearingMode.find((x) => x.label === dataArray[index].clearing).value)
                        }
                        if (dataArray[index].installment) {
                              fd.append("installment", dataArray[index].installment)
                        }

                        for (var i = 1; i <= parseInt(dataArray[index].installment); i++) {
                                    if (dataArray[index]["date"+i]) {
                                          var day = dataArray[index]["date"+i]  % 100;
                                          var month = (parseInt(dataArray[index]["date"+i] / 100) % 100)
                                          var year = (parseInt(dataArray[index]["date"+i] / 10000))

                                          fd.append('date'+i, Moment(JDate.toGregorian(year, month, day)).format('YYYY-MM-DD h:mm:ss'));

                                    }

                              if (dataArray[index]["price"+i]) {

                                    fd.append("price"+i, dataArray[index]["price"+i])

                              }

                        }



                        xhttp.open("POST", `${constants.BASE_URL}/organrequest`)
                        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                        xhttp.send(fd)

                  }else {
                        if (index + 1 < dataArray.length) {
                              this.handleFile(index + 1);
                        }



                  }

            }
            else {
                  this.setState({snackstr: "نام سازمان و قرارداد را انتخاب نمایید", showSnack: true, snackMode: "error"})

            }
      }

      filterList = () => {

      }


      getoptionContract = (organ_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Contract = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Contract.push({ value: arr.data[k].organ_contract_id, label: arr.data[k].organ_contract_num +" "+arr.data[k].company_name+" "+arr.data[k].fieldinsurance_fa   })
                              }
                              self.setState({ optionContract: Contract }, () => {
                                    //   self.getoptionCityID();
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_contract_byorgan")
            fd.append("organ_contract_organ_id", organ_id)
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionOrgan = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].organ_id, label: arr.data[k].organ_name })
                              }
                              self.setState({ optionOrgan: Organ }, () => {
                                    //   self.getoptionCityID();
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_organ")
            xhttp.open("POST", `${constants.BASE_URL}/Organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Fieldinsurance = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Fieldinsurance.push({ value: arr.data[k].fieldinsurance_id, label: arr.data[k].fieldinsurance_fa,fieldinsurance: arr.data[k].fieldinsurance })
                              }
                              self.setState({ optionFieldinsurance: Fieldinsurance }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionAgent = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Agent = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Agent.push({ value: arr.data[k].agent_id, label: arr.data[k].agent_code  })
                              }
                              self.setState({ optionAgent: Agent }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_agent")
            xhttp.open("POST", `${constants.BASE_URL}/agent`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].company_id, label: arr.data[k].company_name,company_logo_url: arr.data[k].company_logo_url })
                              }
                              self.setState({ optionCompany: Company }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionEmployee = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Employee = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Employee.push({ value: arr.data[k].employee_id, label: arr.data[k].employee_family })
                              }
                              self.setState({ optionEmployee: Employee }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee")
            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionClearingMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].request_ready_clearing_mode_id, label: arr.data[k].request_ready_clearing_mode_name })
                              }
                              self.setState({ optionClearingMode: Organ }, () => {
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_clearingmode")
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }




      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }


      handleContract = (selectedContract) => {
            this.setState({ selectedContract: selectedContract }, () => {
            })
      }

      handleOrgan = (selectedOrgan) => {
            this.setState({ selectedOrgan: selectedOrgan }, () => {
                  this.getoptionContract(selectedOrgan.value)
            })
      }






      handleChange = (e) => {
            const { requestinfos } = this.state
            const files = e.target.files
            if (files && files[0]) {
                  this.setState({ file: files[0] }, () => {
                        /* Boilerplate to set up FileReader */
                        const reader = new FileReader()
                        const rABS = !!reader.readAsBinaryString

                        reader.onload = (e) => {
                              /* Parse data */
                              const bstr = e.target.result
                              const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array", bookVBA: true })
                              /* Get first worksheet */
                              const wsname = wb.SheetNames[0]
                              const ws = wb.Sheets[wsname]
                              /* Convert array of arrays */
                              const data = XLSX.utils.sheet_to_json(ws)
                              /* Update state */
                              var sumPay = 0
                              var temparray = requestinfos

                              console.log(data)
                              this.setState({ requestinfos: data, agentInfofilter: data }, () => {this.checkRequest()})

                              // this.setState({ requestinfos: temparray, arrayPay: data, sumPay: sumPay, cols: make_cols(ws["!ref"]) }, () => {
                              //       //console.log(JSON.stringify(this.state.data, null, 2));
                              // })
                        }

                        if (rABS) {
                              reader.readAsBinaryString(this.state.file)
                        } else {
                              reader.readAsArrayBuffer(this.state.file)
                        }
                  })
            }
      }

      checkRequest= () => {
            const { agentInfofilter,optionCompany,optionClearingMode, optionAgent,optionFieldinsurance,optionEmployee,selectedOrgan } = this.state
            var statusTxt=""
            var status=0
            var data=agentInfofilter
            for (var index = 0; index < data.length; index++) {
                  statusTxt='';
                  status=0;
                  if (data[index].fieldinsurance) {

                        console.log(optionFieldinsurance.find((x) => x.label ===  data[index].fieldinsurance  ))
                        if(!optionFieldinsurance.find((x) => x.label ===  data[index].fieldinsurance  ))
                        {
                              statusTxt+='رشته بیمه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='رشته بیمه خالی است.  ';
                        status=1;
                  }

                  if (data[index].agent_code) {

                        console.log(optionAgent.find((x) => parseInt(x.label) ===  parseInt(data[index].agent_code  )))
                        if(!optionAgent.find((x) => parseInt(x.label) ===  parseInt(data[index].agent_code  )))
                        {
                              statusTxt+='نماینده بیمه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='نماینده بیمه بیمه خالی است.  ';
                        status=1;
                  }


                  if (data[index].company_name) {

                        console.log(optionCompany.find((x) => x.label ===  data[index].company_name  ))
                        if(!optionCompany.find((x) => x.label ===  data[index].company_name  ))
                        {
                              statusTxt+='شرکت بیمه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='شرکت بیمه بیمه خالی است.  ';
                        status=1;
                  }

                  if (data[index].num_ins) {
                        if( data[index].num_ins===''||data[index].num_ins===null)
                        {
                              statusTxt+='شماره بیمه نامه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='شماره بیمه نامه خالی است.  ';
                        status=1;
                  }

                  if (data[index].requst_end_price) {
                        if(parseInt(data[index].requst_end_price)===0|| data[index].requst_end_price===''||data[index].requst_end_price===null)
                        {
                              statusTxt+='شماره بیمه نامه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='شماره بیمه نامه خالی است.  ';
                        status=1;
                  }

                  if (data[index].sodor_date) {
                        if( data[index].sodor_date===''||data[index].sodor_date===null)
                        {
                              statusTxt+='تاریخ صدور بیمه نامه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='تاریخ صدور بیمه نامه خالی است.  ';
                        status=1;
                  }

                  if (data[index].start_date) {
                        if( data[index].start_date===''||data[index].start_date===null)
                        {
                              statusTxt+='تاریخ شروع بیمه نامه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='تاریخ شروع بیمه نامه خالی است.  ';
                        status=1;
                  }

                  if (data[index].end_date) {
                        if( data[index].end_date===''||data[index].end_date===null)
                        {
                              statusTxt+='تاریخ پایان بیمه نامه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='تاریخ پایان بیمه نامه خالی است.  ';
                        status=1;
                  }



                  if (data[index].name_insurer) {
                        if( data[index].name_insurer===''||data[index].name_insurer===null)
                        {
                              statusTxt+='نام بیمه گزار وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='نام بیمه گزار خالی است.  ';
                        status=1;
                  }


                  if (data[index].name_client) {
                        if( data[index].name_client===''||data[index].name_client===null)
                        {
                              statusTxt+='نام سفارش دهنده وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='نام بیمه گزار خالی است.  ';
                        status=1;
                  }

                  if (data[index].family_client) {
                        if( data[index].family_client===''||data[index].name_client===null)
                        {
                              statusTxt+='فامیلی سفارش دهنده وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='فامیلی بیمه گزار خالی است.  ';
                        status=1;
                  }

                  if (data[index].nationalcode_insurer) {
                        if( data[index].nationalcode_insurer===''||data[index].nationalcode_insurer===null)
                        {
                              statusTxt+='کد ملی بیمه گزار وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='کد ملی بیمه گزار خالی است.  ';
                        status=1;
                  }

                  if (data[index].personalcode_client) {
                        if( data[index].personalcode_client===''||data[index].personalcode_client===null)
                        {
                              statusTxt+='کد پرسنلی بیمه گزار وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='کد پرسنلی بیمه گزار خالی است.  ';
                        status=1;
                  }

                  if (data[index].mobile_client) {
                        if( data[index].mobile_client===''||data[index].mobile_client===null)
                        {
                              statusTxt+=' موبایل سفارش دهنده وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='موبایل  سفارش دهنده خالی است.  ';
                        status=1;
                  }



                  if (data[index].nationalcode_client) {
                        if( data[index].nationalcode_client===''||data[index].nationalcode_client===null)
                        {
                              statusTxt+='کد ملی سفارش دهنده وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='کد ملی سفارش دهنده خالی است.  ';
                        status=1;
                  }

                  if (data[index].employee_name) {
                        console.log(optionEmployee.find((x) => x.label ===  data[index].employee_name  ))
                        if(!optionEmployee.find((x) => x.label ===  data[index].employee_name  ))
                        {
                              statusTxt+='کارمند وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='کارمند خالی است.  ';
                        status=1;
                  }

                  if (data[index].clearing) {
                        console.log(optionClearingMode.find((x) => x.label ===  data[index].clearing  ))
                        if(!optionClearingMode.find((x) => x.label ===  data[index].clearing  ))
                        {
                              statusTxt+='نوع تسویه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='نوع تسویه  خالی است.  ';
                        status=1;
                  }

                  if (data[index].installment) {
                        if( data[index].installment===''||data[index].installment===null)
                        {
                              statusTxt+=' تعداد اقساط ییمه نامه وجود ندارد.  ';
                              status=1;
                        }else{
                              //*********************************************************
                              for (var i = 1; i <= parseInt(data[index].installment); i++) {
                                    if (data[index]["date"+i]) {
                                          if (data[index]["date"+i] === '' || data[index]["date"+i] === null) {
                                                statusTxt += 'تاریخ قسط '+i+' بیمه  نامه وجود ندارد.  ';
                                                status = 1;
                                          }
                                    } else {
                                          statusTxt += 'تاریخ قسط '+i+' بیمه نامه خالی است.  ';
                                          status = 1;
                                    }

                                    if (data[index]["price"+i]) {
                                          if (data[index]["price"+i] === '' || data[index]["price"+i] === null) {
                                                statusTxt += 'مبلغ قسط '+i+' بیمه  نامه وجود ندارد.  ';
                                                status = 1;
                                          }
                                    } else {
                                          statusTxt += 'مبلغ قسط '+i+' بیمه نامه خالی است.  ';
                                          status = 1;
                                    }

                              }
                              //*********************************************************
                        }
                  }else {
                        statusTxt+=' تعداد اقساط ییمه نامه خالی است.  ';
                        status=1;
                  }



                  if (data[index].price1) {
                        if( data[index].price1===''||data[index].price1===null)
                        {
                              statusTxt+='مبلغ قسط اول بیمه  نامه وجود ندارد.  ';
                              status=1;
                        }
                  }else {
                        statusTxt+='مبلغ قسط اول بیمه نامه خالی است.  ';
                        status=1;
                  }

                  data[index].status = status;
                  data[index].statusTxt = statusTxt;
            }
            this.setState({ requestinfos: data, agentInfofilter: data }, () => {})

      }






      onSelectOptionOrgan = (selectedList, selectedItem) => {
            this.setState(
                {
                      selectedFilterOrgan: selectedList,
                },
                () => {
                }
            )
      }








      render() {
            const { classes } = this.props
            const {
                  optionContract,
                  optionOrgan,
                  optionClearingMode,
                  selectedContract,
                  selectedOrgan,
                  snackMode,
                  snackstr,
                  showSnack,
                  organ_user_therapy,
                  newKindOrganrequest,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
                  showPaperChart,
                  showPaperChart2,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                      <div className={classes.paperrtl} dir="ltr">
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container component="main" maxWidth="lg">
                                              <Paper elevation={4} className={classes.root}>
                                                    <Grid container spacing={3}>


                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">سازمان</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"سازمان"}
                                                                          value={selectedOrgan}
                                                                          onChange={this.handleOrgan}
                                                                          options={optionOrgan}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">قرارداد</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"قرارداد"}
                                                                          value={selectedContract}
                                                                          onChange={this.handleContract}
                                                                          options={optionContract}
                                                                      />
                                                                </div>
                                                          </Grid>
                                                          <Grid item xs={4}>
                                                                <div>
                                                                      <label htmlFor="file">آپلود لیست سازمان </label>
                                                                      <br />
                                                                      <input
                                                                          type="file"
                                                                          className="form-control"
                                                                          id="file"
                                                                          accept={SheetJSFT}
                                                                          onChange={this.handleChange}
                                                                      />

                                                                </div>
                                                          </Grid>
                                                          <Grid item xs={4}>
                                                                <Button variant="outlined" color="primary"
                                                                        onClick={ (event) => {
                                                                              this.handleFile(0)
                                                                        }}>
                                                                      {" ارسال لیست به سرور"}
                                                                </Button>
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  {newKindOrganrequest&&showPaperChart2 ? (
                                      <Grid item xs={12}>
                                            <Container component="main" maxWidth="lg">
                                                  <Paper elevation={4} className={classes.root}>


                                                        <Collapse in={showPaperChart2}>
                                                              <Button variant="outlined" color="primary" onClick={ (event) => {
                                                                    this.setState({ showPaperChart2: false })
                                                              }}>
                                                                    {"مخفی کردن"}
                                                              </Button>
                                                              <Grid container spacing={3}>
                                                                    <Grid item xs={6}>
                                                                          <Typography align="center" variant="h7">
                                                                                {"آی دی: " + organ_user_therapy.organ_user_therapy_id}
                                                                          </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={6}>

                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                          <div>
                                                                                <label className="on">شرکت بیمه</label>
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"شرکت بیمه"}

                                                                                    value={optionClearingMode.find((x) => parseInt(x.value) ===  parseInt(organ_user_therapy.company_name))}
                                                                                    onChange={(e) => {  this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,company_name:e.value},
                                                                                        })
                                                                                    } }

                                                                                    options={optionClearingMode}
                                                                                />
                                                                          </div>                                                            </Grid>


                                                                    <Grid item xs={4}>
                                                                          <FloatingLabelInput
                                                                              placeholder="شماره سفارش "
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,id:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.id}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                          <FloatingLabelInput
                                                                              placeholder="  کد نماینده"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,agent_code:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.agent_code}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                          <FloatingLabelInput
                                                                              placeholder="شماره بیمه نامه"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,num_ins:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.num_ins}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              placeholder="نام پدر"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,fieldinsurance:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.fieldinsurance}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              placeholder=" کد پرسنلی سرپرست"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,code_yekta:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.code_yekta}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              placeholder=" کد رایانه"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,code_rayane:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.code_rayane}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              placeholder="قیمت نهایی"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,requst_end_price:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.requst_end_price}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={2}>
                                                                          <FloatingLabelInput
                                                                              placeholder="تاریخ شروع"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,start_date:e},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.start_date}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={2}>
                                                                          <FloatingLabelInput
                                                                              placeholder=" ماه"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,sodor_date:e},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.sodor_date}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                          <FloatingLabelInput
                                                                              type={"number"}
                                                                              placeholder="جزیمه "
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,requst_penalty:e},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.requst_penalty}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              placeholder="نام کارمند"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,employee_name:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.employee_name}
                                                                          />
                                                                    </Grid>

                                                                                                                                        <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder="کد ملی سفارش دهنده "
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,nationalcode_client:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.nationalcode_client}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder=" موبایل سفارش دهنده "
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,mobile_client:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.mobile_client}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              placeholder="نام  سفارش دهنده"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,name_client:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.name_client}
                                                                          />
                                                                    </Grid>


                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              placeholder="فامیلی سفارش دهنده"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,family_client:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.family_client}
                                                                          />
                                                                    </Grid>


                                                                                                                                        <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder="کد پرسنلی بیمه گزار"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,personalcode_client:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.personalcode_client}
                                                                          />
                                                                    </Grid>


                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              placeholder="نام بیمه گزار"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,name_insurer:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.name_insurer}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder="تاریخ پایان"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,end_date:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.end_date}
                                                                          />
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder="کد ملی بیمه گزار"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,nationalcode_insurer:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.nationalcode_insurer}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder="کد ملی بیمه شده اصلی"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,clearing:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.clearing}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder="تعداد اقساط"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,installment:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.installment}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder="تاریخ قسط اول"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,date1:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.date1}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={6}>
                                                                          <FloatingLabelInput
                                                                              placeholder="مبلغ قسط اول"
                                                                              handleInputt={(e) => {
                                                                                    this.setState(
                                                                                        {
                                                                                              organ_user_therapy: {...organ_user_therapy,price1:e.target.value},
                                                                                        })
                                                                              }
                                                                              }
                                                                              value={organ_user_therapy.price1}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={6}>
                                                                          <Button variant="outlined" color="primary" onClick={ (event) => {
                                                                                this.setState({ showPaperChart2: false })
                                                                          }}>
                                                                                {"مخفی کردن"}
                                                                          </Button>
                                                                          {"       "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.newKindOrganrequestFunc()
                                                                              }}
                                                                          >
                                                                                {"تغییر"}
                                                                          </Button>

                                                                    </Grid>
                                                              </Grid>
                                                        </Collapse>
                                                  </Paper>
                                            </Container>
                                      </Grid>
                                  ):""}

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <TableContainer dir="rtl">
                                                          <Table aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell>
                                                                                  <ExcelFile
                                                                                      element={
                                                                                            <Button variant="outlined" color="primary">
                                                                                                  {" "}
                                                                                                  {"اکسل "}
                                                                                            </Button>
                                                                                      }
                                                                                  >
                                                                                        <ExcelSheet data={agentInfofilter} name="نمایندگان">
                                                                                              <ExcelColumn
                                                                                                  label="id"
                                                                                                  value="id"
                                                                                              />
                                                                                              <ExcelColumn
                                                                                                  label="agent_code"
                                                                                                  value="agent_code"
                                                                                              />
                                                                                              <ExcelColumn label="id" value="id" />
                                                                                              <ExcelColumn label="agent_code" value="agent_code" />
                                                                                              <ExcelColumn label="code_yekta" value="code_yekta" />
                                                                                              <ExcelColumn label="code_rayane" value="code_rayane" />
                                                                                              <ExcelColumn label="company_name" value="company_name" />
                                                                                              <ExcelColumn label="requst_penalty" value="requst_penalty" />
                                                                                              <ExcelColumn label="sodor_date" value="sodor_date" />
                                                                                              <ExcelColumn label="start_date" value="start_date" />
                                                                                              <ExcelColumn label="fieldinsurance" value="fieldinsurance" />
                                                                                              <ExcelColumn label="end_date" value="end_date" />
                                                                                              <ExcelColumn label="name_client" value="name_client" />
                                                                                              <ExcelColumn label="family_client" value="family_client" />
                                                                                              <ExcelColumn label="nationalcode_client" value="nationalcode_client" />
                                                                                              <ExcelColumn label="mobile_client" value="mobile_client" />
                                                                                              <ExcelColumn label="personalcode_client" value="personalcode_client" />
                                                                                              <ExcelColumn label="name_insurer" value="name_insurer" />
                                                                                              <ExcelColumn label="nationalcode_insurer" value="nationalcode_insurer" />
                                                                                              <ExcelColumn label="employee_name" value="employee_name" />
                                                                                              <ExcelColumn label="requst_end_price" value="requst_end_price" />
                                                                                              <ExcelColumn label="num_ins" value="num_ins" />
                                                                                              <ExcelColumn label="installment" value="installment" />
                                                                                              <ExcelColumn label="date1" value="date1" />
                                                                                              <ExcelColumn label="price1" value="price1" />
                                                                                              <ExcelColumn label="clearing" value="clearing" />

                                                                                        </ExcelSheet>
                                                                                  </ExcelFile>
                                                                            </TableCell>


                                                                            <TableCell
                                                                                key={"id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"شماره سفارش"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "id"}
                                                                                      direction={orderBy === "id" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"company_name"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={
                                                                                      orderBy === "company_name" ? order : false
                                                                                }
                                                                            >
                                                                                  {"شرکت بیمه "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "company_name"}
                                                                                      direction={
                                                                                            orderBy === "company_name"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("company_name")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"fieldinsurance"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" رشته بیمه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldinsurance"}
                                                                                      direction={
                                                                                            orderBy === "fieldinsurance" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldinsurance")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>




                                                                            <TableCell
                                                                                key={"agent_code"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"کد نماینده"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "agent_code"}
                                                                                      direction={orderBy === "agent_code" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("agent_code")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"num_ins"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"شماره بیمه نامه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "num_ins"}
                                                                                      direction={orderBy === "num_ins" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("num_ins")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell key={"code_yekta"} align={"center"} style={{ minWidth: 60 }}>
                                                                                  {"  کد یکتا"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "code_yekta"}
                                                                                      direction={orderBy === "code_yekta" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("code_yekta")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"code_rayane"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" کد رایانه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "code_rayane"}
                                                                                      direction={orderBy === "code_rayane" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("code_rayane")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"requst_end_price"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" قیمت نهایی"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requst_end_price"}
                                                                                      direction={orderBy === "requst_end_price" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("requst_end_price")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>





                                                                            <TableCell
                                                                                key={"requst_penalty"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"جریمه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requst_penalty"}
                                                                                      direction={orderBy === "requst_penalty" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("requst_penalty")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"sodor_date"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"تاریخ صدور"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "sodor_date"}
                                                                                      direction={orderBy === "sodor_date" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("sodor_date")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"start_date"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"تاریخ شروع"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "start_date"}
                                                                                      direction={orderBy === "start_date" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("start_date")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>





                                                                            <TableCell
                                                                                key={"end_date"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ پایان"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "end_date"}
                                                                                      direction={orderBy === "end_date" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("end_date")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"nationalcode_client"}
                                                                                align={"center"}
                                                                            >
                                                                                  {"کد ملی سفارش دهنده"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "nationalcode_client"}
                                                                                      direction={orderBy === "nationalcode_client" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("nationalcode_client")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"personalcode_client"}
                                                                                align={"center"}
                                                                            >
                                                                                  {"کد پرسنلی بیمه گزار"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "personalcode_client"}
                                                                                      direction={orderBy === "personalcode_client" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("personalcode_client")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"name_client"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نام بیمه گزار"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "name_client"}
                                                                                      direction={orderBy === "name_client" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("name_client")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"family_client"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"فامیلی بیمه گزار"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "family_client"}
                                                                                      direction={orderBy === "family_client" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("family_client")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>


                                                                            <TableCell
                                                                                key={"nationalcode_client"}
                                                                                align={"center"}
                                                                            >
                                                                                  {"موبایل  سفارش دهنده"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "mobile_client"}
                                                                                      direction={orderBy === "mobile_client" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("mobile_client")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"name_insurer"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نام بیمه گزار"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "name_insurer"}
                                                                                      direction={orderBy === "name_insurer" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("name_insurer")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"nationalcode_insurer"}
                                                                                align={"center"}
                                                                            >
                                                                                  {"کد ملی بیمه گزار"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "nationalcode_insurer"}
                                                                                      direction={orderBy === "nationalcode_insurer" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("nationalcode_insurer")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>




                                                                            <TableCell
                                                                                key={"employee_name"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" نام کارمند"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "employee_name"}
                                                                                      direction={orderBy === "employee_name" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("employee_name")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"clearing"}
                                                                                align={"center"}
                                                                            >
                                                                                  {"نوع تسویه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "clearing"}
                                                                                      direction={orderBy === "clearing" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("clearing")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"nationalcode_client"}
                                                                                align={"center"}
                                                                            >
                                                                                  {"تعداد اقساط"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "installment"}
                                                                                      direction={orderBy === "installment" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("installment")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date1"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط اول"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date1"}
                                                                                      direction={orderBy === "date1" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date1")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price1"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط اول"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price1"}
                                                                                      direction={orderBy === "price1" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price1")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date2"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط دوم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date2"}
                                                                                      direction={orderBy === "date2" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date2")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price2"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط دوم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price2"}
                                                                                      direction={orderBy === "price2" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price2")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date3"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط سوم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date3"}
                                                                                      direction={orderBy === "date3" ? order :"asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date3")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price3"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط سوم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price3"}
                                                                                      direction={orderBy === "price3" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price3")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date4"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط چهار"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date4"}
                                                                                      direction={orderBy === "date4" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date4")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price4"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط چهار"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price4"}
                                                                                      direction={orderBy === "price4" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price4")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date5"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط پنچم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date5"}
                                                                                      direction={orderBy === "date5" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date5")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price5"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط پنچم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price5"}
                                                                                      direction={orderBy === "price5" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price5")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date6"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط ششم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date6"}
                                                                                      direction={orderBy === "date6" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date6")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price6"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط ششم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price6"}
                                                                                      direction={orderBy === "price6" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price6")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date7"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط هفتم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date7"}
                                                                                      direction={orderBy === "date7" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date7")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price7"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط هفتم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price7"}
                                                                                      direction={orderBy === "price7" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price7")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date8"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط هشتم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date8"}
                                                                                      direction={orderBy === "date8" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date8")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price8"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط هشتم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price8"}
                                                                                      direction={orderBy === "price8" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price8")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date9"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط نهم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date9"}
                                                                                      direction={orderBy === "date9" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date9")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price9"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط نهم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price9"}
                                                                                      direction={orderBy === "price9" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price9")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date10"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط دهم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date10"}
                                                                                      direction={orderBy === "date10" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date10")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price10"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط دهم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price10"}
                                                                                      direction={orderBy === "price10" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price10")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date11"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط یازدهم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date11"}
                                                                                      direction={orderBy === "date11" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date11")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price11"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط یازدهم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price11"}
                                                                                      direction={orderBy === "price11" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price11")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"date11"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" تاریخ قسط دوازدهم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "date12"}
                                                                                      direction={orderBy === "date12" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("date12")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"price12"}
                                                                                align={"center"}
                                                                            >
                                                                                  {" مبلغ قسط دوازدهم"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "price12"}
                                                                                      direction={orderBy === "price12" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("price12")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"statusTxt"}
                                                                                align={"center"}
                                                                            >
                                                                                  {"وضعیت"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "statusTxt"}
                                                                                      direction={orderBy === "statusTxt" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("statusTxt")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>


                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {agentInfofilter
                                                                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                          .map((row,i) => {
                                                                                return (
                                                                                    <TableRow
                                                                                        hover
                                                                                        role="checkbox"
                                                                                        tabIndex={-1}
                                                                                        style={{background:(row["status"]===1)?'#ff5555':(row["status"]===3)?'#22ff22':(row["status"]===4)?'#22ff99':'#ffffff'}}
                                                                                        key={row["organ_user_therapy_id"]}
                                                                                        value={row}
                                                                                        onClick={() => {
                                                                                              this.handleSelectRows(row,i)
                                                                                        }}
                                                                                    >
                                                                                          <TableCell
                                                                                              key={"organ_user_therapy_id"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {i}
                                                                                          </TableCell>

                                                                                          <TableCell key={"id"} align={"center"}>
                                                                                                {row["id"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"company_name"}
                                                                                              align={"center"}
                                                                                          >

                                                                                                {row["company_name"]}

                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"fieldinsurance"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["fieldinsurance"]}
                                                                                          </TableCell>


                                                                                          <TableCell key={"agent_code"} align={"center"}>
                                                                                                {row["agent_code"]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"num_ins"} align={"center"}>
                                                                                                {row["num_ins"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"code_yekta"} align={"center"}>
                                                                                                {row["code_yekta"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"code_rayane"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["code_rayane"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"requst_end_price"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["requst_end_price"]}
                                                                                          </TableCell>








                                                                                          <TableCell key={"requst_penalty"} align={"center"}>
                                                                                                {row["requst_penalty"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"sodor_date"} align={"center"}>
                                                                                                {row["sodor_date"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"start_date"} align={"center"}>
                                                                                                {row["start_date"]}
                                                                                          </TableCell>




                                                                                          <TableCell key={"end_date"} align={"center"}>
                                                                                                {row["end_date"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"nationalcode_client"} align={"center"}>
                                                                                                {row["nationalcode_client"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"personalcode_client"} align={"center"}>
                                                                                                {row["personalcode_client"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"name_client"} align={"center"}>
                                                                                                {row["name_client"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"family_client"} align={"center"}>
                                                                                                {row["family_client"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"mobile_client"} align={"center"}>
                                                                                                {row["mobile_client"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"name_insurer"} align={"center"}>
                                                                                                {row["name_insurer"]}
                                                                                          </TableCell>


                                                                                          <TableCell key={"nationalcode_insurer"} align={"center"}>
                                                                                                {row["nationalcode_insurer"]}
                                                                                          </TableCell>


                                                                                          <TableCell key={"employee_name"} align={"center"}>
                                                                                                {row["employee_name"]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"clearing"} align={"clearing"}>
                                                                                                {row["clearing"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"installment"} align={"center"}>
                                                                                                {row["installment"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date1"} align={"center"}>
                                                                                                {row["date1"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price1"} align={"center"}>
                                                                                                {row["price1"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date2"} align={"center"}>
                                                                                                {row["date2"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price2"} align={"center"}>
                                                                                                {row["price2"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date3"} align={"center"}>
                                                                                                {row["date3"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price3"} align={"center"}>
                                                                                                {row["price3"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date4"} align={"center"}>
                                                                                                {row["date4"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price4"} align={"center"}>
                                                                                                {row["price4"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date5"} align={"center"}>
                                                                                                {row["date5"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price5"} align={"center"}>
                                                                                                {row["price5"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date6"} align={"center"}>
                                                                                                {row["date6"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price6"} align={"center"}>
                                                                                                {row["price6"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date7"} align={"center"}>
                                                                                                {row["date7"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price7"} align={"center"}>
                                                                                                {row["price7"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date8"} align={"center"}>
                                                                                                {row["date8"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price8"} align={"center"}>
                                                                                                {row["price8"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date9"} align={"center"}>
                                                                                                {row["date9"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price9"} align={"center"}>
                                                                                                {row["price9"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date10"} align={"center"}>
                                                                                                {row["date10"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price10"} align={"center"}>
                                                                                                {row["price10"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date11"} align={"center"}>
                                                                                                {row["date11"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price11"} align={"center"}>
                                                                                                {row["price11"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"date12"} align={"center"}>
                                                                                                {row["date12"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"price12"} align={"center"}>
                                                                                                {row["price12"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"statusTxt"} align={"center"}>
                                                                                                {row["statusTxt"]}
                                                                                          </TableCell>


                                                                                    </TableRow>
                                                                                )
                                                                          })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 100, 1000, 10000,100000]}
                                                        component="div"
                                                        count={agentInfofilter.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>
                                  </Grid>
                            </Grid>

                            {okstatus ? (
                                <Alert severity="success">
                                      <AlertTitle>پیام</AlertTitle>
                                      {errstr}
                                </Alert>
                            ) : null}
                      </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeUserTherapyList)
